import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../components/apiconfig/api-config";
import "../../../App.css"; // Ensure custom CSS is loaded
import { formatDateDDMMYYEmpty } from "../../../components/common/dateUtils";

const formatShipmentDate = (dateString) => {
  if (!dateString) return "-";

  try {
    const date = new Date(dateString);
    const month = date.toLocaleDateString("en-US", { month: "long" });
    const year = date.getFullYear();

    // If it's a single date, return "Month Year"
    return `${month} ${year}`;
  } catch (error) {
    // If it's already in a readable format like "August-September", return as is
    if (typeof dateString === "string" && dateString.includes("-")) {
      return dateString;
    }
    return "-";
  }
};

const SaleContractView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `${API_BASE_URL}/api/sales/sale-contract/${id}`,
          {
            credentials: "include",
          }
        );
        if (!res.ok) throw new Error("Failed to fetch contract details");
        const result = await res.json();
        setData(result.data);
      } catch (err) {
        setError("Failed to load contract details");
      }
      setLoading(false);
    };
    fetchData();
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  if (loading)
    return <div className="text-center py-8 text-blue-600">Loading...</div>;
  if (error)
    return <div className="text-center py-8 text-red-600">{error}</div>;
  if (!data) return null;

  const emdValue = parseFloat(data.emd);
  const emdDisplay =
    data.emd !== null &&
    data.emd !== undefined &&
    data.emd !== "" &&
    !Number.isNaN(emdValue) &&
    emdValue !== 0
      ? `${emdValue.toLocaleString("en-IN", {
          maximumFractionDigits: 2,
        })}% of Contract Value`
      : "-";

  return (
    <div className="contract-view max-w-3xl mx-auto bg-white p-6 border rounded shadow print:shadow-none print:border-0 print:p-0">
      {/* Print/Back Buttons */}
      <div className="flex justify-between items-center mb-4 print:hidden">
        <button
          onClick={() => navigate(-1)}
          className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-3 py-1 rounded"
        >
          Back
        </button>
        <button
          onClick={handlePrint}
          className="bg-[#3899cf] hover:bg-[#0e8dc6] text-white px-3 py-1 rounded"
        >
          Print
        </button>
      </div>
             {/* PAGE 1 */}
       <div className="page-break-after p-4">
         {/* TOP SECTION - Header */}
         <div className="flex items-start justify-between mb-4">
           <img
             src={require("../../../assets/logo-kribhcoAgri.png")}
             alt="Kribhco Logo"
             className="h-14 w-auto mr-2"
           />
           <div className="flex-1 text-right">
             <div className="font-bold text-base leading-tight">
               Kribhco Agri Business Limited
             </div>
             <div className="text-xs leading-tight">
               A-60, KAILASH COLONY, NEW DELHI
               <br />
               SOUTH DELHI, DELHI, 110048, INDIA
               <br />
               EMAIL: neerajsharma@kribhcoagri.in
               <br />
               PHONE: +91 98919 03122
             </div>
             <div className="text-xs mt-1">
               CONTRACT DATE: {formatDateDDMMYYEmpty(data.contract_date)}
             </div>
             <div className="text-xs">
               CONTRACT NO.: {data.sales_contract_no}
             </div>
           </div>
         </div>
         
         {/* CENTER SECTION - Title */}
         <div className="text-center mb-4">
           <div className="font-bold text-lg underline">SALES CONTRACT</div>
         </div>
         
         {/* BOTTOM SECTION - Content */}
       {/* BOTTOM SECTION - Content */}
<div className="border-t-2 border-gray-300 pt-4">
  <div className="mb-4 flex items-start">
  <div className="font-semibold text-sm w-[200px] flex-shrink-0">SELLER</div>
  <div className="flex-1 text-sm text-left">
    <div className="mb-1 font-bold">
      {data.seller_business_name || "-"}
    </div>
    <div className="mb-1">{data.seller_address || "-"}</div>
    <div className="mb-1">EMAIL: {data.seller_email || "-"}</div>
    <div className="mb-1">PHONE: {data.seller_phone || "-"}</div>
    <div className="mb-1">IEC CODE: {data.seller_iec || "-"}</div>
    <div className="mb-1">GST NO.: {data.seller_gst || "-"}</div>
    <div className="mb-1">FSSAI NO: {data.seller_fssai || "-"}</div>
  </div>
</div>

<div className="mb-4 flex items-start">
  <div className="font-semibold text-sm w-[200px] flex-shrink-0">
    SELLER'S BANK DETAILS
  </div>
  <div className="flex-1 text-sm text-left">
    <div className="mb-1">{data.seller_bank_name || "-"}</div>
    <div className="mb-1">{data.seller_bank_address || "-"}</div>
    <div className="mb-1">TEL: {data.seller_phone || "-"}</div>
    <div className="mb-1">A/C NO.: {data.seller_bank_acno || "-"}</div>
    <div className="mb-1">IFSC CODE: {data.seller_bank_ifsc || "-"}</div>
  </div>
</div>

  <div className="mb-4 flex items-start">
    <div className="font-semibold text-sm w-[200px] flex-shrink-0">BUYER</div>
    <div className="flex-1 text-sm text-left">
      <div className="mb-1 font-bold">
        {data.domestic_buyer_name || "-"}
      </div>
      <div className="mb-1">{data.buyer_address || "-"}</div>
      <div className="mb-1">GST: {data.buyer_gst || "-"}</div>
      <div className="mb-1">EMAIL: {data.buyer_email || "-"}</div>
    </div>
  </div>

  <div className="mb-2 flex items-start">
    <div className="font-semibold text-sm w-[200px] flex-shrink-0">
      TRADE DATE
    </div>
    <div className="flex-1 text-sm text-left">
      {formatDateDDMMYYEmpty(data.trade_date) || "-"}
    </div>
  </div>

  <div className="mb-2 flex items-start">
    <div className="font-semibold text-sm w-[200px] flex-shrink-0">
      TYPE OF TRANSACTION
    </div>
    <div className="flex-1 text-sm text-left">
      {data.type_of_transaction || "-"}
    </div>
  </div>

  <div className="mb-2 flex items-start">
    <div className="font-semibold text-sm w-[200px] flex-shrink-0">BROKER</div>
    <div className="flex-1 text-sm text-left">
      {data.broker_name || "-"}
    </div>
  </div>

  <div className="mb-2 flex items-start">
    <div className="font-semibold text-sm w-[200px] flex-shrink-0">COMMODITY</div>
    <div className="flex-1 text-sm text-left">
      {data.commodity_name || "-"}
    </div>
  </div>

  <div className="mb-2 flex items-start">
    <div className="font-semibold text-sm w-[200px] flex-shrink-0">QUALITY</div>
    <div className="flex-1 text-sm text-left">
      {data.commodity_name || "-"}
    </div>
  </div>

  <div className="mb-2 flex items-start">
    <div className="font-semibold text-sm w-[200px] flex-shrink-0">QUANTITY</div>
    <div className="flex-1 text-sm text-left">
      {data.contract_quantity_mt
        ? `${data.contract_quantity_mt} MT +/- 5% at seller's option`
        : "-"}
    </div>
  </div>

  <div className="mb-2 flex items-start">
    <div className="font-semibold text-sm w-[200px] flex-shrink-0">PRICE</div>
    <div className="flex-1 text-sm text-left">
      {data.sale_price_per_mt
        ? `₹${data.sale_price_per_mt} PER METRIC TONS`
        : "-"}
    </div>
  </div>

  <div className="mb-2 flex items-start">
    <div className="font-semibold text-sm w-[200px] flex-shrink-0">
      DELIVERY POINT
    </div>
    <div className="flex-1 text-sm text-left">
      {data.warehouse_name
        ? `${data.warehouse_name}${
            data.warehouse_location ? `, ${data.warehouse_location}` : ""
          }`
        : data.delivery_point || "-"}
    </div>
  </div>

  <div className="mb-2 flex items-start">
    <div className="font-semibold text-sm w-[200px] flex-shrink-0">
      VESSEL NAME
    </div>
    <div className="flex-1 text-sm text-left">
      {data.vessel_name || "-"}
    </div>
  </div>

  <div className="text-right text-xs mt-2">Page 1 of 3</div>
</div>

       </div>
      {/* PAGE 2 */}
      <div className="page-break-after p-4">
        <div className="flex items-start justify-between mb-4">
          <img
            src={require("../../../assets/logo-kribhcoAgri.png")}
            alt="Kribhco Logo"
            className="h-14 w-auto mr-2"
          />
          <div className="flex-1 text-right">
            <div className="font-bold text-base leading-tight">
              Kribhco Agri Business Limited
            </div>
            <div className="text-xs leading-tight">
              A-60, KAILASH COLONY, NEW DELHI
              <br />
              SOUTH DELHI, DELHI, 110048, INDIA
              <br />
              EMAIL: neerajsharma@kribhcoagri.in
              <br />
              PHONE: +91 98919 03122
            </div>
             <div className="text-xs mt-1">
               CONTRACT DATE: {formatDateDDMMYYEmpty(data.contract_date)}
             </div>
             <div className="text-xs">
               CONTRACT NO.: {data.sales_contract_no}
             </div>
          </div>
        </div>
        <hr className="my-2" />
        <div className="mb-4">
          <div className="font-bold underline text-base mb-2">KEY TERMS:</div>
          <div className="text-sm space-y-1 ml-4">
          <div className="mb-2 flex items-start">
          <div className="font-semibold text-base min-w-[180px]">SHIPMENT</div>
          <div className="flex-1 text-sm text-left">
            {data.expected_shipment_start || data.expected_shipment_end
              ? data.expected_shipment_start && data.expected_shipment_end
                ? `${formatShipmentDate(
                    data.expected_shipment_start
                  )} to ${formatShipmentDate(data.expected_shipment_end)}`
                : formatShipmentDate(
                    data.expected_shipment_start || data.expected_shipment_end
                  )
              : data.delivery_end_date
              ? formatShipmentDate(data.delivery_end_date)
              : "-"}
          </div>
        </div>
            <div className="flex items-start">
              <div className="font-semibold text-base min-w-[180px] mr-2">
                LIFTING PERIOD:
              </div>
              <div className="flex-1 text-sm text-left">
                {data.delivery_start_date && data.delivery_end_date
                  ? `${formatDateDDMMYYEmpty(
                      data.delivery_start_date
                    )} to ${formatDateDDMMYYEmpty(data.delivery_end_date)}`
                  : "-"}
              </div>
            </div>
            <div className="flex items-start">
              <div className="font-semibold text-base min-w-[180px] mr-2">
                PAYMENT TERMS:
              </div>
              <div className="flex-1 text-sm text-left">
                <span className="font-semibold">100% Advance</span>
              </div>
            </div>
            <div className="flex items-start">
              <div className="font-semibold text-base min-w-[180px] mr-2">
                EMD:
              </div>
              <div className="flex-1 text-sm text-left">
                <span className="font-semibold">{emdDisplay}</span>
              </div>
            </div>
            <div className="flex items-start">
              <div className="font-semibold text-base min-w-[180px] mr-2">
                Remark:
              </div>
              <div className="flex-1 text-sm text-left">
                <span className="font-semibold">{data.remarks}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-4">
          <div className="font-bold underline text-base mb-2">OTHER TERMS:</div>
          <ol className="list-decimal ml-8 text-sm space-y-1">
            <li>LOAD QTY +/-5% AT SELLER'S OPTION</li>
            <li>
              In case EMD is not deposited within 3 working days of trade date,
              the trade will become null and void.
            </li>
            <li>
              EMD will be interest free and will be adjusted in the last
              lifting.
            </li>
            <li>
              In case payment is made by lifting period date and material is not
              lifted, the seller at its option may extend the lifting period
              by charging warehousing and other related cost {data.warehouse_charges ? `@₹${parseFloat(data.warehouse_charges).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} per MT per month` : ''}.
            </li>
            <li>
              In case payment is not made by lifting period date, the seller may
              exercise any of the following options at its discretion:
              <ul className="list-disc ml-8 mt-1">
                <li>a. Forfeit the EMD for unlifted quantity and cancel the contract.</li>
                <li>
                  b. Extend the lifting period with levy of carrying cost
                  including finance cost @11% per annum along with warehousing
                  and other related cost{data.warehouse_charges ? `, @₹${parseFloat(data.warehouse_charges).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} per MT per month` : ''} on unlifted quantity.
                </li>
              </ul>
            </li>
            <li>
              GST and any other taxes as applicable will be charged extra at
              actuals.
            </li>
            <li>
              <strong>Force Majeure:</strong> Should any of the force majeure
              circumstances, namely, act of God, natural calamity, fire, change
              in law or government policy, (excluding any stock limits), strikes
              or lockouts by workmen, war, military operations of any nature or
              blockades, prevent the Seller or the Buyer from wholly or
              partially carrying out their contractual obligations under this
              Sales contract, the period stipulated for the performance of this
              Sales Contract shall be extended for as long as these
              circumstances prevail, provided that, in the event of these
              circumstances continuing for more than 15 Working Days, this Sales
              Contract shall stand annulled and no penalty will be levied on
              either the Buyer or the Seller for non-performance of their
              obligations under this Sales Contract.
            </li>
          </ol>
        </div>

        <div className="text-right text-xs mt-2">Page 2 of 3</div>
      </div>
      {/* PAGE 3 */}
      <div>
        <div className="flex items-start justify-between mb-4 p-4">
          <img
            src={require("../../../assets/logo-kribhcoAgri.png")}
            alt="Kribhco Logo"
            className="h-14 w-auto mr-2"
          />
          <div className="flex-1 text-right">
            <div className="font-bold text-base leading-tight">
              Kribhco Agri Business Limited
            </div>
            <div className="text-xs leading-tight">
              A-60, KAILASH COLONY, NEW DELHI
              <br />
              SOUTH DELHI, DELHI, 110048, INDIA
              <br />
              EMAIL: neerajsharma@kribhcoagri.in
              <br />
              PHONE: +91 98919 03122
            </div>
             <div className="text-xs mt-1">
               CONTRACT DATE: {formatDateDDMMYYEmpty(data.contract_date)}
             </div>
             <div className="text-xs">
               CONTRACT NO.: {data.sales_contract_no}
             </div>
          </div>
        </div>
        <hr className="my-2" />
        <div className="mb-4">
          <ol className="list-decimal ml-8 text-sm space-y-1" start={8}>
            <li>
              <strong>ARBITRATION:</strong> If any dispute, controversy or claim
              arises out of or in connection with this Sales Contract, including
              any question regarding its existence, validity or termination
              arising out of or in connection with this sales contract, the
              Parties shall use all reasonable endeavors to resolve the matter
              amicably.
            </li>
            <li>
              All Disputes, which are unresolved pursuant to the preceding
              clause and for which a Party wishes to have resolved, shall be
              referred upon the application of any Party for arbitration and
              finally settled in accordance with the rules of Arbitration and
              Conciliation Act 1996 (as amended up to date) or any statutory
              amendments/modifications thereof for the time being in force at
              the date of this Sales Contract ("Rules").
            </li>
            <li>
              The seat of the arbitration shall be Delhi. The language of this
              arbitration shall be English.
            </li>
            <li>
              This sales contract is governed by the Indian Contract Act 1872 as
              amended from time to time.
            </li>
            <li>The courts in Delhi shall have exclusive jurisdiction.</li>
          </ol>
        </div>

                 <div className="text-center mt-8 mb-4">
           <div className="font-bold text-base mb-4">Accepted & Signed By:</div>
         </div>
         
         {/* TOP ROW - Seller and Buyer */}
         <div className="flex justify-between mt-16 p-16 mb-8">
           <div className="text-center">
             <div className="border-t-2 border-black w-32 mx-auto mb-2"></div>
             <div className="font-semibold">Seller</div>
           </div>
           <div className="text-center">
             <div className="border-t-2 border-black w-32 mx-auto mb-2"></div>
             <div className="font-semibold">Buyer</div>
           </div>
         </div>
         
        <div className="text-right text-xs mt-2">Page 3 of 3</div>
      </div>
    </div>
  );
};

export default SaleContractView;
